import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import Loading from '../../hoc/Loading/Loading';
import axios from '../../axios';
import * as actionCreators from '../../modules/actions/index';
import { connect } from 'react-redux';
import * as url from '../../utils/url';
import {whiteLabelStyling,isUserRemoved,groupContentFields, groupPrivacyStatusDesc,genderMapOptions} from '../../utils/constants';
import {toolkitCategories} from '../../utils/categories';
import moment from 'moment';
import { Table, Modal, ModalBody, Button, ListGroupItem, Progress,DropdownMenu,DropdownToggle,Dropdown,Alert } from 'reactstrap'; 
import './ProfilePage.css'; 
import EventList from '../../components/UsersEvents/EventList';



const diversity_array=['dIRole','gender','ethnicity','sexualOrientation','religion', 'veteran','disability']

class ProfileEvents extends Component {
    constructor(props) {
        super(props);
        console.log('profile----', this.props)
        let currentUser = this.props.currentUser ? this.props.currentUser  : this.props.user.profile
        this.state = {
            menu:1,
            currentUser,
            isGeoInput:false,
            geolocate:{},
            showEditProfileInfoModal: false,
         }
      this.timer=null;
    }

    componentDidMount(){
     
      
    }



  renderProfile=()=>{
      return  <EventList currentUser= {this.props.currentUser} />
  }

      render() {
        return this.renderProfile() 
    }
}



const mapStateToProps = state => {
    return {
      user: state.user,
      kpiMaster: state.kpiMaster,
      mappingMaster: state.mappingMaster,
      reports:state.reports
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
      onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
      onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
      updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
      updateReport: (dashboard)=> dispatch(actionCreators.updateReport(dashboard)),
    }
  }


export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(ProfileEvents, axios)));